import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidUsdCircleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1Zm-1 10h2c1.7 0 3 1.3 3 3s-1.3 3-3 3v1c0 .6-.4 1-1 1s-1-.4-1-1v-1H9c-.6 0-1-.4-1-1s.4-1 1-1h4c.6 0 1-.4 1-1s-.4-1-1-1h-2c-1.7 0-3-1.3-3-3s1.3-3 3-3V6c0-.6.4-1 1-1s1 .4 1 1v1h2c.6 0 1 .4 1 1s-.4 1-1 1h-4c-.6 0-1 .4-1 1s.4 1 1 1Z"/>
  </SvgIcon>
}

export default SolidUsdCircleIcon
